<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div v-if="blog_detailLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="blog_detailError" class="mc-error">{{ blog_detailError }}</div>
      <div v-if="blog_detailLoaded" class="mc-blog">
        <div class="mc-blog__text">
          <div v-html="blog_detail.text"></div>
          <section v-if="false" class="mc-blog_detail-slider">
            <div class="mc-blog_detail-slider__wrapper">
              <div class="mc-blog_detail-slider__slider swiper">
                <ul class="mc-blog_detail-slider__list swiper-wrapper">
                  <li class="mc-blog_detail-slider__item swiper-slide">
                    <div class="mc-blog_detail-card">
                      <ul class="mc-blog_detail-card__tools mc-card-tools">
                        <li class="mc-card-tools__item">
                          <button class="mc-card-tools__button simulated-hover" type="button" aria-label="Добавить в избранное">
                            <svg class="mc-card-tools__icon" width="20" height="20" viewBox="0 0 20 20">
                              <use xlink:href="/assets/svg/sprite.svg#icon-favorite"></use>
                            </svg>
                          </button>
                        </li>
                      </ul>
                      <a class="mc-blog_detail-card__image-link" href="#">
                        <img class="mc-blog_detail-card__image" src="/assets/content/blog_detail-img-1.jpg" width="158" height="262" alt="">
                      </a>
                      <div class="mc-blog_detail-card__body">
                        <div class="mc-blog_detail-card__title">
                          <a class="mc-blog_detail-card__title-link" href="#">
                            Лонгслив из кашемира
                          </a>
                        </div>
                        <div class="mc-blog_detail-card__price">
                                                        <span class="mc-blog_detail-card__price-old">
                                                            80 000 ₽
                                                        </span>
                          <span class="mc-blog_detail-card__price-current">
                                                            60 000 ₽
                                                        </span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="mc-blog_detail-slider__item swiper-slide">
                    <div class="mc-blog_detail-card">
                      <ul class="mc-blog_detail-card__labels mc-labels">
                        <li class="mc-labels__item mc-labels__item--orange">
                          %
                        </li>
                      </ul>
                      <ul class="mc-blog_detail-card__tools mc-card-tools">
                        <li class="mc-card-tools__item">
                          <button class="mc-card-tools__button simulated-hover" type="button" aria-label="Добавить в избранное">
                            <svg class="mc-card-tools__icon" width="20" height="20" viewBox="0 0 20 20">
                              <use xlink:href="/assets/svg/sprite.svg#icon-favorite"></use>
                            </svg>
                          </button>
                        </li>
                      </ul>
                      <a class="mc-blog_detail-card__image-link" href="#">
                        <img class="mc-blog_detail-card__image" src="/assets/content/blog_detail-img-1.jpg" width="158" height="262" alt="">
                      </a>
                      <div class="mc-blog_detail-card__body">
                        <div class="mc-blog_detail-card__title">
                          <a class="mc-blog_detail-card__title-link" href="#">
                            Лонгслив из кашемира
                          </a>
                        </div>
                        <div class="mc-blog_detail-card__price">
                                                        <span class="mc-blog_detail-card__price-old">
                                                            80 000 ₽
                                                        </span>
                          <span class="mc-blog_detail-card__price-current">
                                                            60 000 ₽
                                                        </span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="mc-blog_detail-slider__item swiper-slide">
                    <div class="mc-blog_detail-card">
                      <ul class="mc-blog_detail-card__tools mc-card-tools">
                        <li class="mc-card-tools__item">
                          <button class="mc-card-tools__button simulated-hover" type="button" aria-label="Добавить в избранное">
                            <svg class="mc-card-tools__icon" width="20" height="20" viewBox="0 0 20 20">
                              <use xlink:href="/assets/svg/sprite.svg#icon-favorite"></use>
                            </svg>
                          </button>
                        </li>
                      </ul>
                      <a class="mc-blog_detail-card__image-link" href="#">
                        <img class="mc-blog_detail-card__image" src="/assets/content/blog_detail-img-1.jpg" width="158" height="262" alt="">
                      </a>
                      <div class="mc-blog_detail-card__body">
                        <div class="mc-blog_detail-card__title">
                          <a class="mc-blog_detail-card__title-link" href="#">
                            Лонгслив из кашемира
                          </a>
                        </div>
                        <div class="mc-blog_detail-card__price">
                                                        <span class="mc-blog_detail-card__price-old">
                                                            80 000 ₽
                                                        </span>
                          <span class="mc-blog_detail-card__price-current">
                                                            60 000 ₽
                                                        </span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="swiper-scrollbar"></div>
            </div>
          </section>

          <section v-if="false" class="mc-blog_detail-slider">
            <div class="mc-blog_detail-slider__wrapper">
              <div class="mc-blog_detail-slider__slider swiper">
                <ul class="mc-blog_detail-slider__list swiper-wrapper">
                  <li class="mc-blog_detail-slider__item swiper-slide">
                    <div class="mc-blog_detail-card">
                      <ul class="mc-blog_detail-card__tools mc-card-tools">
                        <li class="mc-card-tools__item">
                          <button class="mc-card-tools__button simulated-hover" type="button" aria-label="Добавить в избранное">
                            <svg class="mc-card-tools__icon" width="20" height="20" viewBox="0 0 20 20">
                              <use xlink:href="/assets/svg/sprite.svg#icon-favorite"></use>
                            </svg>
                          </button>
                        </li>
                      </ul>
                      <a class="mc-blog_detail-card__image-link" href="#">
                        <img class="mc-blog_detail-card__image" src="/assets/content/blog_detail-img-1.jpg" width="158" height="262" alt="">
                      </a>
                      <div class="mc-blog_detail-card__body">
                        <div class="mc-blog_detail-card__title">
                          <a class="mc-blog_detail-card__title-link" href="#">
                            Лонгслив из кашемира
                          </a>
                        </div>
                        <div class="mc-blog_detail-card__price">
                                                        <span class="mc-blog_detail-card__price-old">
                                                            80 000 ₽
                                                        </span>
                          <span class="mc-blog_detail-card__price-current">
                                                            60 000 ₽
                                                        </span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="mc-blog_detail-slider__item swiper-slide">
                    <div class="mc-blog_detail-card">
                      <ul class="mc-blog_detail-card__labels mc-labels">
                        <li class="mc-labels__item mc-labels__item--orange">
                          %
                        </li>
                      </ul>
                      <ul class="mc-blog_detail-card__tools mc-card-tools">
                        <li class="mc-card-tools__item">
                          <button class="mc-card-tools__button simulated-hover" type="button" aria-label="Добавить в избранное">
                            <svg class="mc-card-tools__icon" width="20" height="20" viewBox="0 0 20 20">
                              <use xlink:href="/assets/svg/sprite.svg#icon-favorite"></use>
                            </svg>
                          </button>
                        </li>
                      </ul>
                      <a class="mc-blog_detail-card__image-link" href="#">
                        <img class="mc-blog_detail-card__image" src="/assets/content/blog_detail-img-1.jpg" width="158" height="262" alt="">
                      </a>
                      <div class="mc-blog_detail-card__body">
                        <div class="mc-blog_detail-card__title">
                          <a class="mc-blog_detail-card__title-link" href="#">
                            Лонгслив из кашемира
                          </a>
                        </div>
                        <div class="mc-blog_detail-card__price">
                                                        <span class="mc-blog_detail-card__price-old">
                                                            80 000 ₽
                                                        </span>
                          <span class="mc-blog_detail-card__price-current">
                                                            60 000 ₽
                                                        </span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="mc-blog_detail-slider__item swiper-slide">
                    <div class="mc-blog_detail-card">
                      <ul class="mc-blog_detail-card__tools mc-card-tools">
                        <li class="mc-card-tools__item">
                          <button class="mc-card-tools__button simulated-hover" type="button" aria-label="Добавить в избранное">
                            <svg class="mc-card-tools__icon" width="20" height="20" viewBox="0 0 20 20">
                              <use xlink:href="/assets/svg/sprite.svg#icon-favorite"></use>
                            </svg>
                          </button>
                        </li>
                      </ul>
                      <a class="mc-blog_detail-card__image-link" href="#">
                        <img class="mc-blog_detail-card__image" src="/assets/content/blog_detail-img-1.jpg" width="158" height="262" alt="">
                      </a>
                      <div class="mc-blog_detail-card__body">
                        <div class="mc-blog_detail-card__title">
                          <a class="mc-blog_detail-card__title-link" href="#">
                            Лонгслив из кашемира
                          </a>
                        </div>
                        <div class="mc-blog_detail-card__price">
                                                        <span class="mc-blog_detail-card__price-old">
                                                            80 000 ₽
                                                        </span>
                          <span class="mc-blog_detail-card__price-current">
                                                            60 000 ₽
                                                        </span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="swiper-scrollbar"></div>
            </div>
          </section>
          <router-link to="/blog/" class="mc-button simulated-hover" >
                            <span class="mc-button__text">
                                Вернуться ко всем новостям
                            </span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import blog_detail from "@/store/blog_detail";

export default {
  computed: {
    ...mapGetters([
      'blog_detail',
      'blog_detailLoading',
      'blog_detailError',
      'blog_detailLoaded'
    ])
  },
  mounted() {

  },
  created() {
    this.fetchBlog_detail(this.$route.params.id);
  },
  components: {},
  methods: {
    ...mapActions([
      'fetchBlog_detail',
    ]),
  },
}
</script>

